// What a face-swap batch takes from the balance, as the server charges it
// (CoreCredits::Allocator, one reservation per task): each task is charged on
// its own, credit types paying in the policy's order at their multiplier, so
// free credits count double. Amounts are cents. Returns the total and the
// extra each credit type adds over the base cost. What the wallet can't cover
// is counted at face value: the server refuses the batch anyway.
// test/lib/face_swap_charge_parity_test.rb checks it against the allocator.
export function chargeTasks(baseCostsCents, availableCents = {}, policy = {}) {
  const available = { ...availableCents }
  const { priority = [], multipliers = {} } = policy
  const extra = {}
  let total = 0

  baseCostsCents.forEach(baseCents => {
    let remaining = baseCents
    for (const type of priority) {
      if (remaining === 0) break
      const multiplier = Number(multipliers[type] ?? 1)
      const spendable = available[type] || 0
      const coverable = Math.floor(spendable / multiplier)
      if (coverable <= 0) continue

      const base = Math.min(remaining, coverable)
      const charged = Math.min(Math.ceil(base * multiplier), spendable)
      available[type] = spendable - charged
      extra[type] = (extra[type] || 0) + charged - base
      total += charged
      remaining -= base
    }
    total += remaining
  })

  return { total, extra }
}
